export default "__VITE_ASSET__BkmXRxOa__"